import AudioStreamCapture from './AudioStreamCapture'

export default AudioStreamCapture
